<template>
    <header
        class="site header"
        role="banner">
        <div
            class="ux container">
            <div
                class="logo section">
                <content-item
                    bundle-name="Header"
                    item-key="LOGO_LEFT"
                    class="d-inline-block mt-3">
                </content-item>
                <content-item
                    bundle-name="Header"
                    item-key="LOGO_RIGHT"
                    class="float-right mt-5">
                </content-item>
            </div>
        </div>
    </header>
</template>

<script>
import PgbaBaseComponent from '../../common/components/PgbaBaseComponent.vue';
export default {
    name: 'HeaderComponent',
    extends: PgbaBaseComponent
};
</script>